<template>
  <div class="aw-top-menu-wrap top_box">
    <div class="container">
      <div class="aw-logo hidden-xs">
        <h2><a @click="$router.push('/index')">{{$t('nav.title')}}</a></h2>
      </div>
      <!-- 导航 -->
      <div class="aw-top-nav navbar">
        <div class="navbar-header">
          <button class="navbar-toggle pull-left" type="button" data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1" aria-expanded="true">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <nav role="navigation" class="collapse navbar-collapse bs-navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav">
            <li v-for="(item, index) in navArr" :key="index" @click.stop="clickLi(item, index)" v-show="!item.hidden">
              <a :class="{ active: navIndex == index }"> {{ item.title }}</a>
              <span class="badge badge-important" style="display:none" id="notifications_unread">0</span>
              <div class="aw-dropdown hidden-xs" v-show="item.path == '/notice'">
                <div class="mod-body">
                  <ul id="header_notification_list">
                    <p class="aw-padding10" align="center" @click.stop="">{{$t('nav.noNoTice')}}</p>
                  </ul>
                </div>
                <div class="mod-footer">
                  <a @click.stop="$router.push('/notice')">{{$t('nav.lookAll')}}</a>
                </div>
              </div>
            </li>
          </ul>
        </nav>
      </div>
      <!-- 手机端面顶部展示 -->
      <div class="aw-logo visible-xs-block">
        <a @click="$router.push('/index')" v-if="navArr[navIndex]">{{ navArr[navIndex].title }}</a>
      </div>
      <!-- 用户栏 -->
      <!-- 登录注册 -->
      <div class="aw-user-nav" v-show="navIndex == 0 && !ifLogin">
        <a class="login btn btn-normal btn-default" @click="$router.push('/login')">{{$t('nav.login')}}</a>
        <a class="register btn btn-normal btn-default" @click="$router.push('/signup')">{{$t('nav.register')}}</a>
      </div>
      <!-- 头像 -->
      <div class="aw-user-nav" v-show="navIndex != 0 || ifLogin">
        <a class="aw-user-nav-dropdown" @click="$router.push('/accountsetting')">
          <img alt="用户名" src="../assets/imgs/avatar-mid-img.png">
        </a>
        <div class="aw-dropdown dropdown-list pull-right">
          <ul class="aw-dropdown-list">
            <li><a @click="goAccountsetting"><i class="icon icon-setting"></i> {{$t('nav.set')}}</a></li>
            <li><a @click="logout()"><i class="icon icon-logout"></i>{{$t('nav.logout')}}</a></li>
          </ul>
        </div>
      </div>

      <!-- 剩多少 -->
      <div class="hidden-xs pull-right header_integral" v-show="navIndex == 3">
        <!-- <a @click="goAddfunds">{{$t('nav.remainingPoints')}}:{{asset.point}}&nbsp;&nbsp;<span>{{$t('nav.remainingArticles')}}{{asset.articleCnt}}</span>&nbsp;&nbsp;
          <code>{{$t('nav.recharge')}}</code></a> -->
          <a style="cursor:auto">
            {{$t('nav.remainingPoints')}}:{{asset.point}}&nbsp;&nbsp;
            <!-- <span>{{$t('nav.remainingArticles')}}{{asset.articleCnt}}</span>&nbsp;&nbsp; -->
          </a>
      </div>
        <!-- 切换语言 -->
      <div class="aw-user-nav switch_language_box">
        <div class="switch_language">{{$t('common.language')}}<a class="el-icon-arrow-down"></a></div>
        <div class="aw-dropdown dropdown-list pull-right">
          <ul class="aw-dropdown-list">
            <li @click="switchLanguage(0)">中文</li>
            <li @click="switchLanguage(1)">繁体</li>
            <li @click="switchLanguage(2)">English</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import {memberInfo} from "@/api/index.js"
import { $t } from "@/lang/index.js"
export default {
  data() {
    return {
      member:{},
      asset:{},
      navArr: [
        {
          title: $t("nav.index"),
          path: "/index",
          hidden: false
        },
        {
          title: $t("nav.mustRead"),
          path: "/mustRead",
          hidden: false
        },
        {
          title: $t("nav.billingMethod"),
          path: "/billingMethod",
          hidden: false
        },
        {
          title: $t("nav.adminConsole"),
          path: "/adminConsole",
          hidden: false
        },
        {
          title: $t("nav.notice"),
          path: "/notice",
          hidden: false
        }
      ],
      navIndex: 0,
      ifLogin:false,
    };
  },
  created() {
    let loginInfo = localStorage.getItem("token");
    if(loginInfo){
      this.ifLogin = true
      this.getMemberInfo();
    }
    this.setNavIndex();
  },
  mounted() {

  },
  methods: {
    switchLanguage(index) {
      let langArr = ['zh_CN', 'zh_HK', 'en_US']
      let lang = langArr[index]
      this.$i18n.locale = lang
      localStorage.setItem("language", lang)
      window.location.reload()
    },
    getMemberInfo(){
      memberInfo().then(response => {
        if(response.code!=200){
          this.$message({
            message:response.msg, // 提示内容
            duration:1500, // 提示持续时间，可省略
            type:'error' // success成功 warning警告 info消息 error错误
          })
        }else{
          this.member = response.data.member;
          this.asset = response.data.memberAsset;
        }
      });
    },
    logout(){
      localStorage.removeItem("token");
      console.log(this.$route.path);
      if(this.$route.path == '/index'){
        location.reload()
      }else{
        this.$router.push("/index")
      }
    },
    clickLi(item) {
      this.$router.push(item.path);
      this.setNavIndex();
    },
    setNavIndex() {
      let href = location.href;
      if (href.includes("/accountsetting")) this.navIndex = null;
      if (href.includes("/reset")) this.navIndex = null;
      if (href.includes("/verify")) this.navIndex = null;

      if (href.includes("/index")) this.navIndex = 0;
      if (href.includes("/mustRead")) this.navIndex = 1;
      if (href.includes("/article")) this.navIndex = 1;
      if (href.includes("/billingMethod")) this.navIndex = 2;
      if (href.includes("/adminConsole")) this.navIndex = 3;
      if (href.includes("/addfunds")) this.navIndex = 3;
      if (href.includes("/webmanage")) this.navIndex = 3;
      if (href.includes("/push")) this.navIndex = 3;
      if (href.includes("/webkeywords")) this.navIndex = 3;
      if (href.includes("/aisetting")) this.navIndex = 3;
      if (href.includes("/test")) this.navIndex = 3;
      if (href.includes("/data")) this.navIndex = 3;
      if (href.includes("/addsite")) this.navIndex = 3;
      if (href.includes("/massaddtype")) this.navIndex = 3;
      if (href.includes("/articleedit")) this.navIndex = 3;
      if (href.includes("/notice")) this.navIndex = 4;
      if(!this.ifLogin){
        this.navArr[2].hidden = true;
        this.navArr[4].hidden = true;
      }
    },
    goAddfunds() {
      const routerUrl = this.$router.resolve({
        path: '/addfunds',
      })
      window.open(routerUrl.href, '_blank')
    },
    goAccountsetting() {
      const routerUrl = this.$router.resolve({
        path: '/accountsetting',
      })
      window.open(routerUrl.href, '_blank')
    },
  },
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped>
.switch_language_box {
  margin: 0;
  margin-top: 14px;
  padding-bottom: 12px;
  margin-right: 20px;
  cursor: pointer;
}
.switch_language {
  color: white;
}
.switch_language a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/top-nav.vue